import { requirePermission } from '@/utils/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import ErrorState from '@/components/Common/ErrorState'
import PageShell from '@/components/Common/PageShell'
import { getDefaultSchedulingBounds } from '@/utils/schedulingBounds'

export const Route = createFileRoute('/scheduling')({
  beforeLoad: () => requirePermission('scheduling'),
  loader: async ({ location }) => {
    if (location.pathname !== '/scheduling') {
      return
    }

    const { startFormatted, endFormatted } = getDefaultSchedulingBounds()

    throw redirect({
      to: '/scheduling/$startDate/$endDate',
      params: {
        startDate: startFormatted,
        endDate: endFormatted,
      },
    })
  },
  errorComponent: ({ error }) => (
    <PageShell title="Error loading schedules" fullWidth>
      <ErrorState title="Failed to load schedules" message={`Unable to load schedules. ${error.message}.`} />
    </PageShell>
  ),
})
